
import React from 'react';
import { TouchableOpacity, Text, StyleSheet, ActivityIndicator } from 'react-native';

interface TertiaryButtonProps {
  title: string;
  onPress: () => void;
  disabled?: boolean;
  loading?: boolean;
}

export default function TertiaryButton({ title, onPress, disabled = false, loading = false }: TertiaryButtonProps) {
  return (
    <TouchableOpacity 
      style={[
        styles.button, 
        disabled && styles.disabledButton
      ]} 
      onPress={disabled || loading ? undefined : onPress}
      disabled={disabled || loading}
      activeOpacity={0.8}
    >
      {loading ? (
        <ActivityIndicator color="#151515" size="small" />
      ) : (
        <Text style={[
          styles.buttonText, 
          disabled && styles.disabledButtonText
        ]}>
          {title}
        </Text>
      )}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    paddingVertical: 12,
    paddingHorizontal: 16,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 12,
    borderRadius: 16,
    backgroundColor: 'transparent',
    height: 48,
    width: '100%',
  },
  disabledButton: {
    backgroundColor: 'transparent',
  },
  buttonText: {
    fontSize: 14,
    fontFamily: 'Inter_500Medium',
    color: '#151515',
    lineHeight: 20,
    textAlign: 'center',
    fontWeight: '500',
  },
  disabledButtonText: {
    color: '#BDC2C8',
  },
});
